import React from "react";

function MirrorLoader({ type = "page", count = 4 }) {
  if (type === "page") {
    return <div className="mirror-progress-bar" role="progressbar" aria-label="Loading page" />;
  }

  if (type === "product-grid") {
    return (
      <div className="row px-2 px-md-0 pe-0 g-3">
        {Array.from({ length: count }).map((_, idx) => (
          <div key={idx} className="col-6 col-xl-3 col-lg-4 col-sm-6 mb-md-4 mb-md-3 mb-3">
            <div className="product-card border-0 shadow-soft h-100 rounded-4 p-3 d-flex flex-column" style={{ minHeight: "350px" }}>
              <div className="mirror-loader-shimmer rounded-3 mb-3 w-100" style={{ aspectRatio: "1/1" }} />
              <div className="mirror-loader-shimmer rounded mb-2 w-75" style={{ height: "20px" }} />
              <div className="mirror-loader-shimmer rounded mb-3 w-50" style={{ height: "16px" }} />
              <div className="mt-auto row g-2">
                <div className="col-12 col-md-6">
                  <div className="mirror-loader-shimmer rounded-pill w-100" style={{ height: "40px" }} />
                </div>
                <div className="col-12 col-md-6">
                  <div className="mirror-loader-shimmer rounded-pill w-100" style={{ height: "40px" }} />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (type === "blog-grid") {
    return (
      <div className="row g-4 px-2 px-md-0">
        {Array.from({ length: count }).map((_, idx) => (
          <div key={idx} className="col-xl-3 col-lg-4 col-md-6">
            <div className="card shadow-sm border-0 rounded-4 overflow-hidden h-100" style={{ minHeight: "350px" }}>
              <div className="mirror-loader-shimmer w-100" style={{ height: "220px" }} />
              <div className="card-body p-4">
                <div className="mirror-loader-shimmer rounded mb-3 w-100" style={{ height: "24px" }} />
                <div className="mirror-loader-shimmer rounded mb-2 w-75" style={{ height: "20px" }} />
              </div>
              <div className="card-footer bg-white border-0 px-4 pb-4 pt-0">
                <div className="mirror-loader-shimmer rounded w-50" style={{ height: "16px" }} />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (type === "hero") {
    return (
      <div className="w-100 hero-slick-wrapper overflow-hidden position-relative" style={{ minHeight: "250px" }}>
        <div className="mirror-loader-shimmer position-absolute top-0 start-0 w-100 h-100" />
      </div>
    );
  }

  // Fallback section shimmer
  return (
    <div className="w-100 py-4">
      <div className="mirror-loader-shimmer rounded-3 mb-3 w-100" style={{ height: "150px" }} />
      <div className="mirror-loader-shimmer rounded mb-2 w-75" style={{ height: "24px" }} />
      <div className="mirror-loader-shimmer rounded mb-2 w-50" style={{ height: "18px" }} />
    </div>
  );
}

export default MirrorLoader;
